import { CanConnectOrBindErrors } from '../../typing';
import { isCountryCodeSubdomain, parseDomain } from '../../utils';
import { ConnectionType } from '@wix/ambassador-premium-domains-v1-connected-domain/types';
export const canConnectOrBindDomain = async _ref => {
  let {
    httpClient,
    request: {
      domain,
      msid
    }
  } = _ref;
  if (!domain) {
    return {
      canConnectOrBind: false
    };
  }
  const parsedDomain = domain.asciiDomain ? domain : parseDomain(domain);
  const rootDomain = parsedDomain.asciiDomain;
  const fullAsciiDomain = parsedDomain.fullAsciiDomain;
  const isSubdomain = !!parsedDomain.subdomain;
  if (isSubdomain) {
    return canConnectOrBindSubdomain({
      httpClient,
      subdomain: fullAsciiDomain,
      rootDomain,
      msid
    });
  } else {
    return canConnectOrBindRootDomain({
      httpClient,
      rootDomain,
      msid
    });
  }
};
async function canConnectOrBindRootDomain(_ref2) {
  let {
    httpClient,
    rootDomain,
    msid
  } = _ref2;
  const {
    checkDomainAvailability,
    userDomain
  } = (await import('../ApiClients/DomainsApiClient')).DomainsApiClient.queries({
    httpClient
  });
  const {
    error: userDomainError,
    site
  } = await userDomain({
    domain: rootDomain,
    withSiteData: !msid
  }, {
    cacheTime: 0
  });
  const isRootDomainInAccount = !userDomainError;
  if (userDomainError === 'belongsToAnotherAccount') {
    return {
      error: CanConnectOrBindErrors.DOMAIN_TAKEN_IN_WIX,
      canConnectOrBind: false
    };
  }
  if (isRootDomainInAccount && !!(site != null && site.siteId)) {
    const metaSiteId = msid ?? site.siteId;
    return {
      error: metaSiteId === site.siteId ? CanConnectOrBindErrors.ALREADY_ASSIGNED_TO_THIS_SITE : CanConnectOrBindErrors.ALREADY_ASSIGNED,
      canConnectOrBind: true,
      assignedSite: site
    };
  }
  try {
    var _availability$availab;
    const availability = await checkDomainAvailability({
      domain: rootDomain
    });
    const isRootDomainAvailable = (_availability$availab = availability.availability) == null ? void 0 : _availability$availab.available;
    if (isRootDomainAvailable) {
      return {
        canConnectOrBind: false
      };
    }
    return {
      canConnectOrBind: true
    };
  } catch (e) {
    var _e$response;
    // Don't delete this part
    const statusCode = (e == null || (_e$response = e.response) == null ? void 0 : _e$response.status) ?? (e == null ? void 0 : e.status);
    if (statusCode !== 400) {
      throw e;
    }
    return {
      canConnectOrBind: false
    };
  }
}
async function canConnectOrBindSubdomain(_ref3) {
  let {
    httpClient,
    subdomain,
    rootDomain
  } = _ref3;
  const {
    getConnectedDomain,
    userDomain
  } = (await import('../ApiClients/DomainsApiClient')).DomainsApiClient.queries({
    httpClient
  });
  const {
    error: useDomainError
  } = await userDomain({
    domain: subdomain
  });
  const isSubdomainInAccount = !useDomainError;
  const ccPremiumError = isCountryCodeSubdomain(subdomain) ? CanConnectOrBindErrors.LANGUAGE_CODE_SUBDOMAIN : undefined;
  if (isSubdomainInAccount) {
    return {
      canConnectOrBind: true,
      error: ccPremiumError
    };
  }
  if (useDomainError === 'belongsToAnotherAccount') {
    return {
      error: CanConnectOrBindErrors.DOMAIN_TAKEN_IN_WIX,
      canConnectOrBind: false
    };
  }
  try {
    const {
      connectedDomain
    } = await getConnectedDomain({
      connectedDomainId: rootDomain
    });
    if ((connectedDomain == null ? void 0 : connectedDomain.connectionType) === ConnectionType.POINTING) {
      return {
        error: CanConnectOrBindErrors.ROOT_DOMAIN_IS_CONNECTED_BY_POINTING,
        canConnectOrBind: false
      };
    }
    return {
      canConnectOrBind: true,
      error: ccPremiumError
    };
  } catch (e) {
    var _e$response2;
    const statusCode = (e == null || (_e$response2 = e.response) == null ? void 0 : _e$response2.status) ?? (e == null ? void 0 : e.status);
    switch (statusCode) {
      case 404:
        {
          return {
            canConnectOrBind: true,
            error: ccPremiumError
          };
        }
      default:
        return {
          canConnectOrBind: false
        };
    }
  }
}
//# sourceMappingURL=canConnectOrBindDomain.js.map